import { InputArea } from '@wix/design-system';
import React from 'react';

import { EDIT_PANEL_HTML_INPUT } from '../../data-hooks';

type HtmlInputAreaProps = {
  placeholder: string;
  value: string;
  onChange: (value: string) => void;
};

export const HtmlInputArea: React.FC<HtmlInputAreaProps> = ({ placeholder, value, onChange }) => {
  return (
    <InputArea
      size="small"
      placeholder={placeholder}
      dataHook={EDIT_PANEL_HTML_INPUT}
      value={value}
      onChange={e => onChange(e.target.value)}
      minHeight="244px"
    />
  );
};
